import { motion, AnimatePresence } from 'framer-motion'
import { useProposalStudio, type ProposalStudioProps } from './useProposalStudio'
import { ProposalStudioHeader } from './ProposalStudioHeader'
import { ProposalStudioItemsView } from './ProposalStudioItemsView'
import { ProposalStudioVisualView } from './ProposalStudioVisualView'

export type { ProposalStudioProps } from './useProposalStudio'

export function ProposalStudio(props: ProposalStudioProps) {
  const s = useProposalStudio(props)

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
      >
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={s.onClose} />

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="relative z-10 bg-[var(--bg-card)] border border-[var(--glass-border)] rounded-xl shadow-2xl overflow-hidden flex flex-col"
          style={{ width: '96vw', height: '94vh', maxWidth: 1400 }}
        >
          <ProposalStudioHeader s={s} />

          <div className="flex flex-1 min-h-0">
            {s.viewMode === 'items' ? (
              <ProposalStudioItemsView s={s} />
            ) : (
              <ProposalStudioVisualView s={s} />
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}
